var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "query-browser" }, [
    _c("div", { staticClass: "browser-header" }, [
      _c("div", { staticClass: "header-actions" }, [
        _c("div", { staticClass: "actions-stats" }, [
          _vm._v(
            "\n                Displaying " +
              _vm._s(_vm.queries.length) +
              " of " +
              _vm._s(_vm.allQueries.length) +
              " queries from " +
              _vm._s(_vm.stats.requestCount) +
              " requests.\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "actions-buttons" }, [
          _c(
            "button",
            {
              staticClass: "button is-info is-small is-icon",
              class: { "is-loading": _vm.isUpdating },
              attrs: { type: "button", disabled: _vm.isLoading },
              on: { click: _vm.manualUpdate },
            },
            [_c("icon", { attrs: { name: "fas fa-sync" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-danger is-small is-icon",
              class: { "is-loading": _vm.isResetting },
              attrs: { type: "button", disabled: _vm.isLoading },
              on: { click: _vm.reset },
            },
            [_c("icon", { attrs: { name: "fas fa-trash-alt" } })],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field has-addons" }, [
        _c(
          "div",
          { staticClass: "icon is-left" },
          [_c("icon", { attrs: { name: "fas fa-search" } })],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "control is-expanded has-icons-left" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchText,
                expression: "searchText",
              },
            ],
            staticClass: "input is-small is-fullwidth",
            attrs: {
              type: "search",
              placeholder: _vm.$pgettext("core.debug", "Search queries..."),
              disabled: _vm.isLoading,
            },
            domProps: { value: _vm.searchText },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.searchText = $event.target.value
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "browser-content" },
      [
        _c("transition-group", { attrs: { name: "fade" } }, [
          _vm.isLoading
            ? _c("div", { key: "loading" }, [_c("loading-indicator")], 1)
            : _c(
                "div",
                { key: "content" },
                [
                  _vm._l(_vm.queries, function (query, index) {
                    return _c("query-item", {
                      key: index,
                      attrs: {
                        query: query,
                        searchText: _vm.searchTextCooled,
                        isCurrentRequest: query.request_id == _vm.requestId,
                      },
                    })
                  }),
                  _vm._v(" "),
                  _vm.hasMoreQueriesToShow
                    ? _c(
                        "a",
                        {
                          staticClass: "show-more",
                          on: { click: _vm.showMore },
                        },
                        [
                          _c("icon", { attrs: { name: "fas fa-plus" } }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$pgettext("core.debug", "Show more")
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }